export class OktaEmployeeModel {
  employeeNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;

  constructor(claims: any) {
    this.employeeNumber = claims?.employeeNumber;
    this.firstName = claims?.firstName;
    this.lastName = claims?.lastName;
    this.email = claims?.sub;
    this.country = claims?.country;
  }
}
